import { useState } from "react";
import { ForceList } from "@/components/force/ForceList";
import { Header } from "@/components/force/Header";
import { Sidebar } from "@/components/force/Sidebar";
import { ValidationBanner } from "@/components/force/ValidationBanner";
import { PrintView } from "@/components/print/PrintView";
import { RosterLibrary } from "@/components/roster/RosterLibrary";
import { Drawer } from "@/components/ui/Drawer";
import { useIsMobile } from "@/hooks/useBreakpoint";
import { useForceStore } from "@/store/forceStore";
import { useUiStore } from "@/store/uiStore";

export function App() {
	const activeRosterId = useForceStore((s) => s.activeRosterId);
	const [showPrintView, setShowPrintView] = useState(false);

	const isMobile = useIsMobile();
	const isSidebarOpen = useUiStore((s) => s.isSidebarOpen);
	const closeSidebar = useUiStore((s) => s.closeSidebar);

	// Landing page — no active roster
	if (!activeRosterId) {
		return <RosterLibrary />;
	}

	// Print view — active roster, print mode
	if (showPrintView) {
		return <PrintView onClose={() => setShowPrintView(false)} />;
	}

	// Force builder — active roster, edit mode
	return (
		<div className="h-dvh flex flex-col bg-bg-primary text-text-primary font-base overflow-hidden">
			<Header onOpenPrintView={() => setShowPrintView(true)} />
			<div className="flex flex-1 overflow-hidden">
				{/* Desktop: inline sidebar */}
				{!isMobile && <Sidebar />}

				{/* Mobile: drawer sidebar */}
				{isMobile && (
					<Drawer isOpen={isSidebarOpen} onClose={closeSidebar}>
						<Sidebar />
					</Drawer>
				)}

				<main className="flex-1 overflow-y-auto p-3 lg:p-6">
					<ForceList />
				</main>
			</div>

			{/* Mobile: sticky validation banner at bottom */}
			{isMobile && <ValidationBanner />}
		</div>
	);
}
